<template>
  <div>
    <el-tabs class="grid-content content-margin">
      <el-tab-pane :label="$t(`message.${this.title}`)">
        <table>
          <!-- 头部按钮 -->
          <tr>
            <OrgButtonArea
              @onEdit="onEdit"
              @onSave="onSave"
              @onRefresh="onRefresh"
              @onCancel="onCancel"
              @onBack="onBack"
              @onAdd="onAdd"
              ref="orgButton"
              :isAddMode="this.isAddMode"
              :isEditMode="this.isEditMode"
            ></OrgButtonArea>
            <el-divider></el-divider>
          </tr>

          <tr>
            <div
              :style="{
                height: this.clientHeight + 'px',
                overflow: 'auto',
              }"
            >
              <table class="simpleRow">
                <tr>
                  <td v-show="!isAddMode" width='10%'>
                    <span class="simpleLabel">ID:</span>
                  </td>
                  <td v-show="!isAddMode" width='35%'>
                    <el-input
                      clearable
                      v-model="serverData.info.jobid"
                      size="small"
                      :disabled="true"
                    />
                  </td>
                  <td width='5%'></td>
                  <td width='10%' >
                    <span class="simpleLabel">{{$t('message.名称')}}</span>
                  </td>
                  <td width='40%'>
                    <el-input
                      clearable
                      v-model="serverData.info.name"
                      size="small"
                      :disabled="!isEditMode && !isAddMode"
                    />
                  </td>
                </tr>
              </table>

              <table class="simpleRow">
                <tr>
                  <td width='10%'>
                    <span class="simpleLabel">{{$t('message.状态')}}</span>
                  </td>
                  <td>
                    <el-radio-group
                      v-model="serverData.info.state"
                      :disabled="!isEditMode && !isAddMode"
                    >
                      <el-radio :label="0">{{$t('message.普通')}}</el-radio>
                      <el-radio :label="1">{{$t('message.禁用')}}</el-radio>
                      <el-radio :label="2">{{$t('message.删除')}}</el-radio>
                    </el-radio-group>
                  </td>
                </tr>
              </table>

              <table class="simpleRow">
                <tr>
                  <td width="10%">
                    <span class="simpleLabel">{{$t('message.所属部门')}}</span>
                  </td>
                  <td>
                    <el-select
                      v-model="serverData.info.departmentid"
                      :placeholder="$t('message.请选择')"
                      :disabled="!isEditMode && !isAddMode"
                      :popper-append-to-body="false"
                    >
                      <el-option
                        v-for="item in parentObjOption"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                      >
                      </el-option>
                    </el-select>
                  </td>
                </tr>
              </table>

              <table class="simpleRow">
                <tr>
                  <td width='10%'>
                    <span class="simpleLabel">{{$t('message.备注')}}</span>
                  </td>
                   <td width='90%'>
                    <el-input
                      type="textarea"
                      :rows="3"
                      :placeholder="$t('message.请输入内容')"
                      v-model="serverData.comment"
                      :disabled="!isEditMode && !isAddMode"
                    >
                    </el-input>
                  </td>
                </tr>
              </table>

              <!-- 编辑修改信息 -->
              <div v-show="!isAddMode">
                <el-divider></el-divider>
                <EditInfo
                  v-show="!isAddMode"
                  ref="jeei"
                  :createdate="serverData.info.createdate"
                  :editdate="serverData.info.editdate"
                ></EditInfo>
              </div>
            </div>
          </tr>
        </table>
      </el-tab-pane>

      <el-tab-pane :label="$t('message.权限信息')">
        <table>
          <!-- 头部按钮 -->
          <tr>
            <OrgButtonArea
              @onEdit="onEdit"
              @onSave="onSave"
              @onRefresh="onRefresh"
              @onCancel="onCancel"
              @onBack="onBack"
              @onAdd="onAdd"
              ref="orgButton"
              :isAddMode="this.isAddMode"
              :isEditMode="this.isEditMode"
            ></OrgButtonArea>
            <el-divider></el-divider>
          </tr>

          <tr>
            <div
              :style="{
                height: this.clientHeight + 'px',
                overflow: 'auto',
              }"
            >
              <span class="simpleLabel">{{$t('message.权限设置')}}</span>
              <div
                v-for="(module, indexModule) in this.moduleAuthTable"
                :key="indexModule"
              >
                <div
                  class="grid-content content-margin"
                  v-show="module.auth.length && module.authGroup != 1 && module.authGroup != 3"
                >
                  <div  style="font-size:18px">{{
                    module.define
                  }}</div>
                  <el-checkbox
                    :style="{ marginLeft: '20px',marginTop: '15px',width:'110px' }"
                    v-model="checkAll[indexModule]"
                    @change="onCheckAll($event, indexModule)"
                    display="flex"
                    :disabled="!isEditMode && !isAddMode"
                  >
                    {{$t('message.全选')}}
                  </el-checkbox>
                  <div class="grid-content content-margin" style="margin-top:10px">
                    <el-checkbox
                      v-for="auth in module.auth"
                      v-model="auth.check"
                      :key="auth.functionID"
                      :label="auth.chinese"
                      v-bind:title="auth.chineseHelp"
                      :style="{ width: '180px','margin-top':'10px' }"
                      :disabled="!isEditMode && !isAddMode"
                    >
                    </el-checkbox>
                  </div>
                </div>
              </div>
            </div>
          </tr>
        </table>
      </el-tab-pane>

      <el-tab-pane :label="$t('message.员工信息')">
        <table>
          <!-- 头部按钮 -->
          <tr>
            <OrgButtonArea
              @onEdit="onEdit"
              @onSave="onSave"
              @onRefresh="onRefresh"
              @onCancel="onCancel"
              @onBack="onBack"
              @onAdd="onAdd"
              ref="orgButton"
              :isAddMode="this.isAddMode"
              :isEditMode="this.isEditMode"
            ></OrgButtonArea>
            <el-divider></el-divider>
          </tr>

          <tr>
            <div
              :style="{
                height: this.clientHeight + 'px',
                overflow: 'auto',
              }"
            >
              <div class="buttonarea" v-show="isEditMode || isAddMode">
                <el-link :underline="false">
                  <el-button
                    size="medium"
                    round
                    @click="isShowAppendEmployee = true"
                  >
                    <i class="el-icon-user-solid"></i>
                    {{$t('message.添加员工')}}
                  </el-button>
                </el-link>
              </div>

              <div :style="{ 'margin-top': '20px' }" class="employee">
                <el-table
                  :data="serverData.employees"
                  border
                  stripe
                  style="width: 100%"
                  height="100%"
                >
                <el-table-column
                    type="index"
                    width="50"
                  >
                  </el-table-column>
                  <el-table-column
                    sortable
                    prop="backaccountid"
                    label="ID"
                    align="center"
                    min-width="100"
                    max-width="200"
                  >
                  </el-table-column>

                  <el-table-column
                    sortable
                    prop="workname"
                    :label="$t('message.工作名')"
                    align="center"
                    min-width="150"
                    max-width="200"
                  >
                  </el-table-column>

                  <el-table-column
                    sortable
                    prop="contact"
                    align="center"
                    :label="$t('message.联系方式')"
                    width="150"
                  >
                  </el-table-column>

                  <el-table-column width="150" sortable :label="$t('message.状态')">
                    <template slot-scope="scope">
                      <span>{{ $t(`message.${getAccountStateName(scope.row.state)}`) }}</span>
                    </template>
                  </el-table-column>

                  <el-table-column fixed="right" :label="$t('message.操作')" width="120">
                    <template slot-scope="scope">
                      <el-button
                        @click.native.prevent="deleteRow(scope.$index)"
                        type="text"
                        size="small"
                        v-show="isEditMode"
                      >
                        {{$t('message.移除')}}
                      </el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
          </tr>
        </table>
      </el-tab-pane>
    </el-tabs>

    <shade v-if="isShowAppendEmployee">
      <EmployeeStore
        @onCancelAppenEmployee="onCancelAppenEmployee"
        @onAppendEmployee="onAppendEmployee"
        v-bind:excludeList="serverData.employees"
      ></EmployeeStore>
    </shade>
  </div>
</template>

<script>
import EditInfo from "@/components/Organization/EditInfo.vue";
import OrgButtonArea from "@/components/Organization/OrgButtonArea.vue";
import moduleAuthUtil from "@/utils/ModuleAuthUtil";
import EmployeeStore from "@/components/Organization/EmployeeStore.vue";
import shade from "@/components/shade/shade";
import commonUtil from "@/utils/commonUtil";
import {rejecthttp,changeflagCLOSED} from "@/utils/request";

export default {
  name: "JobEdit",
  components: {
    EditInfo,
    OrgButtonArea,
    EmployeeStore,
    shade,
  },

  props: {
    clientHeight: 0,
    isAddMode: false,
    jobid: null,
  },

  data() {
    return {
      isEditMode: false,
      isShowAppendEmployee: false,
      title: "岗位信息",
      serverData: {
        info: {
          appid: 188,
          departmentid: null,
          state: 0,
          name: "",
        },
        auths: [],
        employees: [],
      },

      parentObjOption: [],

      checkAll: [],
      moduleAuthTable: [],
    };
  },

  methods: {
    deleteRow(index) {
      this.serverData.employees.splice(index, 1);
    },

    getAccountStateName(state) {
      return commonUtil.getAccountStateName(state);
    },

    onAppendEmployee(data) {
      data.forEach((item) => {
        this.serverData.employees.push(item);
      });
      this.isShowAppendEmployee = false;
    },

    onCancelAppenEmployee() {
      this.isShowAppendEmployee = false;
    },

    onCheckAll(val, indexModule) {
      for (var k = 0; k < this.moduleAuthTable[indexModule].auth.length; k++) {
        this.moduleAuthTable[indexModule].auth[k].check =
          this.checkAll[indexModule];
      }
    },

    onChangeParentType() {
      this.$emit("getParentObj", 2, (val) => {
        this.parentObjOption = val;
        if (val.length) {
          this.serverData.info.departmentid = this.parentObjOption[0].id;
        } else {
          this.serverData.info.departmentid = null;
        }
      });
    },

    onEdit() {
      this.isEditMode = true;
    },

    onCancel() {
      this.isEditMode = false;
    },

    onRefresh() {
      if (this.jobid == null) {
        return;
      }
      rejecthttp(true,'get',"/manage/organization/job/getjobinfo",{
            appid: this.serverData.info.appid,
            jobid: this.jobid,
          },this,(doc) => {
            changeflagCLOSED(doc,0,this)
            if(doc.data.Code == "MSGKEY_OK"){
            this.serverData = doc.data.data;
            this.getAuths();
            this.$refs.jeei.getServerData(doc.data.exData.datas);
            }
            })
      // this.$http
      //   .get("/manage/organization/job/getjobinfo", {
      //     params: {
      //       appid: this.serverData.info.appid,
      //       jobid: this.jobid,
      //     },
      //   })
      //   .then((doc) => {
      //     if (doc.data.Code != "MSGKEY_OK") {
      //       this.$message({
      //         type: "error",
      //         message: doc.data.Message,
      //       });
      //     } else {
      //       this.serverData = doc.data.data;
      //       this.getAuths();
      //       this.$refs.jeei.getServerData(doc.data.exData.datas);
      //     }
      //   });
    },

    onSave() {
      if (this.serverData.info.name.length == 0) {
        this.$alert({
          type: "error",
          message: this.$t('message.岗位名称不能为空'),
        });
        return;
      }

      this.setAuths();
      rejecthttp(true,'post',"/manage/organization/job/updatejob",this.serverData,this,(doc) => {
            changeflagCLOSED(doc,1,this)
            if(doc.data.Code == "MSGKEY_OK"){
              this.onBack();
            }
            })
      // this.$http
      //   .post("/manage/organization/job/updatejob", this.serverData)
      //   .then((doc) => {
      //     if (doc.data.Code != "MSGKEY_OK") {
      //       this.$message({
      //         type: "error",
      //         message: doc.data.Message,
      //       });
      //     } else {
      //       this.$message({
      //         type: "success",
      //         message: "保存成功",
      //       });
      //       this.onBack();
      //     }
      //   });
    },

    onBack() {
      this.isEditMode = false;
      this.$emit("onBack");
    },

    onAdd() {
      if (this.serverData.info.name.length == 0) {
        this.$message({
          type: "error",
          message: this.$t('message.岗位名称不能为空'),
        });
        return;
      }
      if (this.serverData.info.departmentid == null) {
        this.$message({
          type: "error",
          message: this.$t('message.请选择所属部门'),
        });
        return;
      }

      //设置权限信息
      this.setAuths();
      rejecthttp(true,'post',"/manage/organization/job/addjob",this.serverData,this,(doc) => {
            changeflagCLOSED(doc,1,this)
            if(doc.data.Code == "MSGKEY_OK"){
              this.onBack();
            }
            })
      // this.$http
      //   .post("/manage/organization/job/addjob", this.serverData)
      //   .then((doc) => {
      //     if (doc.data.Code != "MSGKEY_OK") {
      //       this.$message({
      //         type: "error",
      //         message: doc.data.Message,
      //       });
      //     } else {
      //       this.$message({
      //         type: "success",
      //         message: doc.data.Message,
      //       });
      //       this.onBack();
      //     }
      //   });
    },

    setAuths() {
      this.moduleAuthTable.forEach((module) => {
        if (module.auth.length) {
          module.id;
          var autroption = 0;
          module.auth.forEach((auth) => {
            if (auth.check == true) {
              autroption |= auth.value;
            }
          });

          //查找id相等的,设值
          var finded = false;
          for (var i = 0; i < this.serverData.auths.length; i++) {
            if (this.serverData.auths[i].authorityid == module.id) {
              this.serverData.auths[i].authorityoptions = autroption;
              finded = true;
            }
          }
          if (!finded) {
            this.serverData.auths.push({
              appid: 188,
              jobid: this.jobid,
              authorityid: module.id,
              authorityoptions: autroption,
            });
          }
        }
      });
    },

    getAuths() {
      this.serverData.auths.forEach((item) => {
        for (var i = 0; i < this.moduleAuthTable.length; i++) {
          if (this.moduleAuthTable[i].id == item.authorityid) {
            for (var k = 0; k < this.moduleAuthTable[i].auth.length; k++) {
              if (
                item.authorityoptions & this.moduleAuthTable[i].auth[k].value
              ) {
                this.moduleAuthTable[i].auth[k].check = true;
              }
            }
          }
        }
      });
    },
  },

  created() {
    this.moduleAuthTable = moduleAuthUtil.getModuleAuthTable();

    for (var i = 0; i < this.moduleAuthTable.length; i++) {
      //全选默认为false
      this.checkAll[i] = false;
    }

    this.onChangeParentType();
  },

  mounted: function () {},

  watch: {
    clientHeight: {
      handler(val, oldVal) {},
      deep: true,
      immediate: true,
    },
    isAddMode: {
      handler(val, oldVal) {
        if (val == true) {
          this.title = "添加岗位";
          //清空旧数据
          for (let key in this.serverData.info) {
            if (key != "appid" && key != "state") {
              this.serverData.info[key] = null;
            }
          }
          this.serverData.info.auths = this.serverData.employees.splice(
            0,
            this.serverData.employees.length
          );
        } else {
          this.title = "岗位信息";
        }
      },
    },
    jobid: {
      handler(val, oldVal) {
        this.onRefresh();
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>

<style scoped>
.employee{
  overflow: auto;
  height: 90%!important;
}
</style>



// WEBPACK FOOTER //
// src/components/Organization/JobEdit.vue